module.exports = __webpack_public_path__ + "img/xiaoguobianji.a417c6c7.png";